module.exports = __webpack_public_path__ + "static/img/zhhq-jdglpt-04.f65a68e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq-jdglpt-04.png
// module id = ICz8
// module chunks = 1